import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1545009850674181';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
function loadPixel() {
  try {
    if (window.fbq) {
      try {
        window.fbq('track', 'PageView');
      } catch (_) {
        /* swallow */
      }
      return;
    }
    ;
    (function (f: any, b: any, e: any, v: any) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        try {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        } catch (_) {
          /* swallow */
        }
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e);
      t.async = !0;
      t.src = v;
      t.onerror = function () {
        /* swallow */
      };
      const s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    try {
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (_) {
      /* swallow */
    }
  } catch (_) {
    /* swallow — page should never crash because of pixel */
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Defer Pixel injection until the browser is idle so it never blocks first paint.
    const ric: any = (window as any).requestIdleCallback;
    if (typeof ric === 'function') {
      ric(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 1500);
    }
  }, []);
  return null;
}
// Helper to track custom events from anywhere in the app
export function trackPixelEvent(event: string, data?: Record<string, any>) {
  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', event, data);
    }
  } catch (_) {
    /* swallow */
  }
}